export default __webpack_public_path__ + "static/media/6.Electro-deionization(EDI).866cb81e.jpg";